import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';

import { ReportBuilderRoutingModule } from './report-builder-routing.module';
import { ReportBuilderPickerComponent } from './pages/report-builder-picker/report-builder-picker.component';
import { ReportBuilderBasicComponent } from './pages/report-builder-basic/report-builder-basic.component';
import { ReportBuilderAggregateComponent } from './pages/report-builder-aggregate/report-builder-aggregate.component';

@NgModule({
  declarations: [
    ReportBuilderPickerComponent,
    ReportBuilderBasicComponent,
    ReportBuilderAggregateComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    // CoreModule for <app-grid> (Basic mode).
    CoreModule,
    ReportBuilderRoutingModule
  ]
})
export class ReportBuilderModule { }
